import { render } from "./FileAccess.vue?vue&type=template&id=e0bd4c02"
import script from "./FileAccess.vue?vue&type=script&lang=js"
export * from "./FileAccess.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ardent_dms_v2\\ardent_dms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__